<!--  -->
<template>
  <div class="tree-container">
    <div class="tree-add" @click="addOption">
      <Icon :icon="'add-circle-line'" />
      <span class="add-span">添加选项</span>
    </div>
    <a-tree
      :tree-data="treeSum.treeData"
      @select="treeSelect"
      v-model:selectedKeys="treeSum.selectedKeys"
    >
      <template #title="{ key: treeKey, title,children }">
        <div class="tree-icon" @mouseover="hover = true" @mouseleave="hover = false">
          <span class="icon-title">
            <a-tooltip placement="leftTop">
              <template #title>{{ title }}</template>
              {{ title }}
            </a-tooltip>
          </span>
          <div class="icon">
            <Icon :icon="'add-line'" v-show="hover" @click="iconChange(0,treeKey)" />
          </div>
          <div class="icon">
            <Icon :icon="'edit-2-line'" v-show="hover" @click="iconChange(1,treeKey)" />
          </div>
          <div class="icon" v-if="children && children.length < 1">
            <Icon :icon="'close-circle-line'" v-show="hover" @click.stop="iconChange(2,treeKey)" />
          </div>
        </div>
      </template>
    </a-tree>
  </div>
</template>

<script>
// 导入的其他文件 例如：import moduleName from 'modulePath';
import Icon from "@/layout/icon";
import {
  defineComponent,
  ref,
  watch,
  reactive,
  toRefs,
  watchEffect,
  computed
} from "vue";
import {
  DownOutlined,
  SmileOutlined,
  FrownOutlined,
  FrownFilled
} from "@ant-design/icons-vue";
export default defineComponent({
  name: "treeConfig",
  components: {
    Icon,
    DownOutlined,
    SmileOutlined,
    FrownOutlined,
    FrownFilled
  },
  props: {
    treeSum: Object
  },
  setup(props, { attrs, slots, emit }) {
    const state = reactive({
      hover: false
    });

    const expandedKeys = ref();

    const treeSelect = (selectedKeys, e) => {
      emit("treeSelect", selectedKeys, e);
    };
    const iconChange = (status, treeKey) => {
      emit("iconChange", status, treeKey);
    };

    const addOption = () => {
      emit("addOption");
    };
    const onContextMenuClick = (treeKey, menuKey) => {
      console.log(`treeKey: ${treeKey}, menuKey: ${menuKey}`);
    };
    const confirmPop = () => {
      emit("confirmPop");
    };
    const cancelPop = () => {
      emit("cancelPop");
    };
    let isHasChildren = computed(() => {
      state.treeData.forEach(item => {
        console.log(item, "000008888");
      });
    });
    watch(expandedKeys, () => {
      console.log("expandedKeys", expandedKeys);
    });
    watchEffect(() => {
      console.log(isHasChildren, "isHasChildren");
    });
    return {
      ...toRefs(state),
      onContextMenuClick,
      expandedKeys,
      addOption,
      treeSelect,
      iconChange,
      confirmPop,
      cancelPop
    };
  }
});
</script>
<style lang="less">
.ant-tree li .ant-tree-node-content-wrapper {
  width: 100%;
}
</style>
<style lang='less' scoped>
//@import url(); 引入公共css类
.tree-container {
  width: 30%;
  //   background: red;
  margin-top: 10px;
  padding: 10px 30px;
  .tree-add {
    #flex-box.row-start-c();
    cursor: pointer;
  }
  .tree-icon {
    #flex-box.row-start-c();
    .icon-title {
      // font-size: 16px;
      width: 100px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: keep-all;
      cursor: pointer;
    }
    .icon {
      // font-size: 20px;
      #flex-box.row-start-c();
      margin-left: 5px;
      width: 16px;
      height: 16px;
    }
  }
}
</style>